import styled from 'styled-components';
import colors from '@styles/colors';

export const Container = styled.div`
  padding: 10px;
  width: 100%;
`;

export const Title = styled.div`
  color: ${colors.primary};
  margin: 5px 0 10px 5px;
`;

export const WrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  /* height: 80vh; */
  margin-top: 10px;
`;

export const Table = styled.table`
  display: table;
  border-collapse: collapse;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-x: auto;
  margin-bottom: 10px;
  background: #f5f5f5;

  @media (max-width: 768px) {
    display: block;
  }

  & th {
    padding: 8px;
    background: #777;
    color: #f5f5f5;
    font-weight: normal;
    border: 1px solid #666;
    margin: 0;
  }

  & td {
    padding: 5px;
    text-align: center;
    border: 1px solid #ccc;
  }
`;
